"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: subheadingRef,
    isVisible: subheadingVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="hero" className="dark bg-background text-foreground relative min-h-screen flex items-center justify-center overflow-hidden !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1539347/img/slupsk_legal_branding_pattern.png)]">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-cover bg-top bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1539347/img/image_hrfn6qnw.png)] animate-[zoom-in_20s_ease-out_forwards]" style={{
        animation: "zoom-in 20s ease-out forwards"
      }} />
        <div className="absolute inset-0 bg-dark-background/60" />
      </div>

      {}
      <div className="relative z-10 max-w-5xl mx-auto px-4 py-20 text-center">
        {}
        <div ref={headingRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
        transitionDelay: headingVisible ? "0ms" : "0ms"
      }}>
          <h1 className="font-display font-bold tracking-tight mb-6 text-foreground-dark text-4xl md:text-6xl lg:text-7xl !font-sans">ODSZKODOWANIA SŁUPSK&nbsp; <br />POMOC PRAWNA&nbsp;</h1>
        </div>

        {}
        <div ref={subheadingRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${subheadingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
        transitionDelay: subheadingVisible ? "200ms" : "0ms"
      }}>
          <p className="font-serif leading-relaxed text-foreground-dark/90 max-w-3xl mx-auto mb-8 text-xl md:text-2xl">Pomagamy osobom poszkodowanym <br />w wypadkach oraz ich rodzinom w dochodzeniu odszkodowań i zadośćuczynień z tytułu odpowiedzialności cywilnej sprawcy. Prowadzimy sprawy rzetelnie, <br />z jasnymi zasadami i realnym wsparciem prawnym. Działamy na terenie Słupska i okolic.</p>
        </div>

        {}
        <div ref={ctaRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
        transitionDelay: ctaVisible ? "400ms" : "0ms"
      }}>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild size="lg" className="btn-primary text-lg px-10 py-5 shadow-strong hover:-translate-y-1 hover:shadow-[0_16px_32px_rgb(0_0_0_/_0.2)]">
              <Link to="/ContactPage">Skontaktuj się z nami</Link>
            </Button>
            <Link to="tel:504144406" className="inline-flex items-center gap-2 text-foreground-dark/90 hover:text-foreground-dark text-lg font-sans font-semibold transition-colors duration-150">
              <span className="!text-2xl">504 144 406</span>
            </Link>
          </div>
        </div>
      </div>

      {}
      <style jsx>{`
        @keyframes zoom-in {
          from {
            transform: scale(1);
          }
          to {
            transform: scale(1.05);
          }
        }
      `}</style>
    </section>;
}